import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

// Réplica de la cabecera de ActionDialog (headerVariant="brand") del Storybook de Velora.
// El fondo es el color del cliente, no #0176BC.
const ModalHeaderStyled = styled.div`
  .header-modal {
    background-color: ${props => props.theme.primary};
    text-align: left;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 20px 64px 20px 24px;
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;

    path {
      fill: ${props => props.theme.textPrimary};
    }

    p {
      font-family: ${tokens.typography.fontFamily.primary};
      font-weight: 600;
      font-size: 18px;
      line-height: 27px;
      color: ${props => props.theme.textPrimary};
      margin: 0;
      word-break: break-word;
      overflow-wrap: break-word;
    }
  }

  .close-icon {
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    box-sizing: content-box;
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.2s ease;

    :hover {
      background-color: ${color.overlay.onDarkHover};
    }
  }
`

export default ModalHeaderStyled
